export default __webpack_public_path__ + "static/media/sec9img.1845b3bb.png";